import React, { forwardRef } from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  className,
  label,
  ...props
}, ref) => {
  return <label className="flex items-start gap-3 cursor-pointer group" data-id="element-340">
        <div className="relative flex items-center mt-0.5" data-id="element-341">
          <input type="checkbox" className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-primary bg-transparent checked:bg-primary transition-all focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-1 focus:ring-offset-[#1A1A2E]" ref={ref} {...props} data-id="element-342" />
          <Check className="absolute pointer-events-none opacity-0 peer-checked:opacity-100 text-[#1A1A2E] w-3 h-3 left-0.5 top-0.5 transition-opacity" data-id="element-343" />
        </div>
        {label && <span className={cn('text-sm text-gray-400 group-hover:text-white transition-colors select-none', className)} data-id="element-344">
            {label}
          </span>}
      </label>;
});
Checkbox.displayName = 'Checkbox';